import { render, staticRenderFns } from "./ApplicationsMainPage.vue?vue&type=template&id=2d75be7c&scoped=true&"
import script from "./ApplicationsMainPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationsMainPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsMainPage.vue?vue&type=style&index=0&id=2d75be7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75be7c",
  null
  
)

export default component.exports